/*=========================================================================================
  File Name: moduleUserGetters.js
  Description: User Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Useror: SpeedCodeLabs
  Useror URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  GetUser(state) {
    return state.user;
  },
  GetPolicies(state) {
    return state.policies;
  },
  GetMenuList(state, getters, rootState) {
    const settings = rootState.sitesetting && rootState.sitesetting.siteSettings;
    const chequeFlag = settings && settings.cheque_enabled;
    const chequeEnabled =
      !settings || chequeFlag === undefined || chequeFlag === null
        ? true
        : chequeFlag === true || chequeFlag === 1 || chequeFlag === "1";
    var items = [
      {
        icon: 'mdi-home-circle-outline',
        'icon-alt': 'mdi-home-circle',
        text: 'Dashboard',
        // model: true,
        link: '/',
        policy: ['Dashboard Index'],
      },
      {
        icon: 'mdi-shopping',
        'icon-alt': 'mdi-shopping',
        text: 'Inventory',
        policy: ['All Inventory Index'],
        children: [
          {
            icon: 'mdi-warehouse',
            'icon-alt': 'mdi-store',
            text: 'Warehouses',
            link: '/warehouse',
            policy: ['Ware House Index'],
          },
          {
            icon: 'mdi-layers-triple-outline',
            'icon-alt': 'mdi-layers-triple',
            text: 'Products',
            link: '/product',
            policy: ['Product Index'],
          },
          {
            icon: 'mdi-storefront-outline',
            'icon-alt': 'mdi-storefront',
            text: 'Purchase Orders',
            link: '/purchase-order',
            policy: ['Purchase Order Index'],
          },
          {
            icon: 'mdi-truck-check-outline',
            'icon-alt': 'mdi-truck-check',
            text: 'Purchases',
            link: '/purchase',
            policy: ['Purchase Index'],
          },
          {
            icon: 'mdi-truck-delivery-outline',
            'icon-alt': 'mdi-truck-delivery',
            text: 'Purchase Returns',
            link: '/purchase-return',
            policy: ['Purchase Return Index'],
          },
          {
            icon: 'mdi-account-multiple-outline',
            'icon-alt': 'mdi-account-multiple',
            text: 'Suppliers',
            link: '/supplier',
            policy: ['Supplier Index'],
          },
          {
            icon: 'mdi-database',
            'icon-alt': 'mdi-database',
            text: 'Stock',
            link: '/stock',
            policy: ['Stocks Show'],
          },
          {
            icon: 'mdi-database-plus',
            'icon-alt': 'mdi-database-plus',
            text: 'Kitchen Transfer',
            link: '/stock-transfer',
            policy: ['Stocks Show'],
          },
          {
            icon: 'mdi-silverware-variant',
            text: 'Kitchen Stocks',
            link: '/kitchen-stocks',
            policy: ['Table Index'],
          },
        ],
      },

      {
        icon: 'mdi-bed-empty',
        'icon-alt': 'mdi-bed',
        text: 'Rooms',
        policy: ['All Rooms Index'],
        children: [
          {
            icon: 'mdi-remote',
            'icon-alt': 'mdi-remote',
            text: 'Amenties',
            link: '/amenties',
            policy: ['Amenity Index'],
          },
          {
            icon: 'mdi-account-box-multiple',
            text: 'Guests',
            link: '/guests',
            policy: ['Guest Index'],
          },
          {
            text: 'Room Type',
            icon: 'mdi-sack-percent',
            'icon-alt': 'mdi-account-multiple-plus',
            link: '/room-type',
            policy: ['Room Type Index'],
          },

          {
            icon: 'mdi-bed-empty',
            'icon-alt': 'mdi-bed',
            text: 'Bed Type',
            link: '/bed-types',
            policy: ['Bed Type Index'],
          },

          // {
          //   icon: "mdi-beach",
          //   "icon-alt": "mdi-beach",
          //   text: "Places",
          //   // model: true,
          //   link: "/places",
          //   policy: ["Amenity Index"],
          // },
          {
            icon: 'mdi-home-variant',
            text: 'Rooms',
            link: '/room',
            policy: ['Room Index'],
          },
          {
            icon: 'mdi-home-modern',
            text: 'Floor',
            link: '/floor',
            policy: ['Room Index'],
          },
          {
            icon: 'mdi-home-circle',
            text: 'Reservation',
            link: '/reservation',
            policy: ['Room Index'],
          },
        ],
      },

      {
        icon: 'mdi-food',
        'icon-alt': 'mdi-food',
        text: 'KOT',
        policy: ['All KOT Index'],
        children: [
          {
            icon: 'mdi-food',
            text: 'Dishes',
            link: '/dishes',
            policy: ['Dish Index'],
          },
          {
            icon: 'mdi-table-multiple',
            text: 'Tables',
            link: '/table',
            policy: ['Table Index'],
          },
          {
            icon: 'mdi-beach',
            text: 'Place',
            link: '/places',
            policy: ['Table Index'],
          },
          {
            icon: 'mdi-table-multiple',
            text: 'Kitchen',
            link: '/kitchens',
            policy: ['Table Index'],
          },
          {
            icon: 'mdi-food-variant',
            text: 'Ingredients',
            link: '/ingredient',
            policy: ['Table Index'],
          },
          {
            icon: 'mdi-human-greeting',
            text: 'Waiter',
            link: '/waiter',
            policy: ['Table Index'],
          },
          {
            icon: 'mdi-file-document',
            text: 'Order Bills',
            link: '/suspended_bills',
            policy: ['Table Index'],
          },
        ],
      },
      {
        icon: 'mdi-file-document-outline',
        'icon-alt': 'mdi-file-document',
        text: 'Reports',
        policy: ['Report Index'],
        children: [
          {
            icon: 'mdi-layers-triple-outline',
            text: 'Product',
            link: '/product-report',
            policy: ['Product Report Index'],
          },
          {
            icon: 'mdi-storefront-outline',
            text: 'Purchase Order',
            link: '/purchase-order-report',
            policy: ['PurchaseOrder Report Index'],
          },
          {
            icon: 'mdi-truck-check-outline',
            text: 'Purchase',
            link: '/purchase-report',
            policy: ['Purchase Report Index'],
          },
          {
            icon: 'mdi-truck-delivery-outline',
            text: 'Purchase Return',
            link: '/purchase-return-report',
            policy: ['PurchaseReturn Report Index'],
          },
          {
            icon: 'mdi-file-check',
            text: 'Kitchen Stock',
            link: '/kitchen-stock-report',
            policy: ['PurchaseReturn Report Index'],
          },
          {
            icon: 'mdi-file-import',
            text: 'Food Order',
            link: '/order-report',
            policy: ['PurchaseReturn Report Index'],
          },
          {
            icon: 'mdi-file-find',
            text: 'Reservation',
            link: '/reservation-report',
            policy: ['PurchaseReturn Report Index'],
          },
          {
            icon: 'mdi-file-plus',
            text: 'Order Food & Product',
            link: '/order-food-product',
            policy: ['PurchaseReturn Report Index'],
          },
          {
            icon: 'mdi-chart-line',
            text: 'Accounting',
            link: '/accounting-report',
            policy: ['Accounting Dashboard'],
          },
        ],
      },
      

       {
        icon: "mdi-cash-multiple",
        text: "Payments",
        link: "/payment",
        policy: ["Payment Index"],
      },
      {
        icon: "mdi-checkbook",
        text: "Cheques",
        link: "/cheque",
        policy: ["Cheques Index"],
      },
            {
            icon: "mdi-chart-line",
            text: "Accounting",
            link: "/accounting",
            policy: ["Accounting Dashboard"],
          },
            {
            icon: "mdi-cash-plus",
            text: "Incomes",
            link: "/incomes",
            policy: ["Income Index"],
          },
            {
            icon: "mdi-checkbook",
            text: "Expenses",
            link: "/expenses",
            policy: ["Expense Index"],
          },
      {
        icon: 'mdi-cog-transfer',
        text: 'Master Data',
        link: '/master-data',
        policy: ['Master Data Index'],
      },
      {
        icon: 'mdi-web',
        text: 'Website',
        children: [
          {
            icon: 'mdi-hotel',
            text: 'Rooms',
            link: '/website/rooms',
            policy: ['Website Rooms Index'],
          },
          {
            icon: 'mdi-home-variant',
            text: 'Banquet Hall',
            link: '/website/hall',
            policy: ['Website Banquet Hall Index'],
          },
          {
            icon: 'mdi-email-outline',
            text: 'Hall Enquiries',
            link: '/website/hall-enquiries',
            policy: ['Website Banquet Hall Index'],
          },
          {
            icon: 'mdi-silverware',
            text: 'Restaurant',
            link: '/website/restaurant',
            policy: ['Website Restaurant Index'],
          },
          {
            icon: 'mdi-information',
            text: 'About',
            link: '/website/about',
            policy: ['Website About Index'],
          },
          {
            icon: 'mdi-phone',
            text: 'Contact',
            link: '/website/contact',
            policy: ['Website Contact Index'],
          },
        ],
      },
      {
        icon: 'mdi-wrench-outline',
        'icon-alt': 'mdi-wrench',
        text: 'Settings',
        policy: ['All Setting Index'],
        children: [
          {
            icon: 'mdi-account-circle-outline',
            text: 'Users',
            link: '/user',
            policy: ['User Index'],
          },
          {
            icon: 'mdi-shield-lock',
            text: 'Roles',
            link: '/role',
            policy: ['Role Index'],
          },
          {
            icon: 'mdi-clipboard-text-clock-outline',
            text: 'Audit Log',
            link: '/audit-log',
            policy: ['Audit Log Index'],
          },
          {
            icon: 'mdi-domain',
            text: 'Organization',
            link: '/setting/organization',
            policy: ['Organization Index'],
          },
          // {
          //   icon: "mdi-account-key",
          //   text: "KOT Setting",
          //   link: "/setting/kot",
          //   policy: ["Pos setting Index"],
          // },
          {
            icon: 'mdi-account-key',
            text: 'KOT Setting',
            link: '/setting/kot',
            policy: ['Kot setting Index'],
          },
          {
            icon: 'mdi-key-variant',
            text: 'Site Configuration',
            link: '/setting/sites',
            policy: ['Site setting Index'],
          },
        ],
      },
    ];
    const permissions =
      state.policies || (state.user && state.user.permissions) || [];
    const itemList = [];

    function hasPolicy(policyNames) {
      if (!policyNames) return true;
      const required = Array.isArray(policyNames) ? policyNames : [policyNames];
      return permissions.some((p) => {
        const name = typeof p === "string" ? p : p && p.name;
        return name && required.includes(name);
      });
    }

    const menuItems = chequeEnabled
      ? items
      : items.filter((item) => item.link !== "/cheque");

    menuItems.forEach((item) => {
      if (item.children) {
        const visibleChildren = item.children
          .filter((child) => hasPolicy(child.policy))
          .map((child) => ({ ...child }));
        if (visibleChildren.length) {
          itemList.push({ ...item, model: false, children: visibleChildren });
        }
      } else if (hasPolicy(item.policy)) {
        itemList.push({ ...item, model: false });
      }
    });
    return itemList;
  },
};
